import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { makeStateKey, PLATFORM_ID, TransferState, inject } from '@angular/core';
import { catchError, of, throwError } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { environment } from 'src/environments/environment';
import { REQUEST } from '../express.token';
import { UtilService } from '../util/util.service';
import { VariablesService } from '../variables/variables.service';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const util = inject(UtilService);
  const vars = inject(VariablesService);
  const request = inject(REQUEST, { optional: true });
  const platformId = inject(PLATFORM_ID);
  const transferState = inject(TransferState);

  const user = util.storage.get('user');
  const token = user?.token || '';
  const isToken = vars.isToken;

  let authReq = req;
  if (isToken && !req.params.get('filter')) {
    authReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token)
    });
  }
  if (isPlatformServer(platformId) && environment.name !== 'local') {
    console.log('[SSR HTTP]', req.urlWithParams);
    if (request) {
      util.setDomainDetails(request?.get('X-Custom-Header') || '');
    }
    const storedResponse: string = transferState.get(makeStateKey(req.url), null as any);
    if (storedResponse) {
      const response = new HttpResponse({ body: storedResponse, status: 200 });
      return of(response);
    }
  }

  return next(authReq).pipe(
    catchError((error) => {
      if (!vars.isBrowser) {
        console.log('error: ', error?.status, error?.error);
        return of(new HttpResponse({
          status: 200,
          body: null // Return null response to prevent SSR crash
        }));
      }
      let postBody: any;
      try {
        if (typeof authReq.body === 'string') {
          postBody = JSON.parse(authReq.body);
        } else {
          postBody = authReq.body;
        }
      } catch { }
      const param = authReq.params.get('showError') || postBody?.showError;
      if (error?.error?.message && param !== 'false' && error?.error?.error !== 'token_expired') {
        util.openSnackBar(error.error.message, 'error');
      }
      if (error?.error?.error === 'token_expired') {
        util.storage.delete('user');
        util.storage.delete('userdata');
        util.storage.deleteFromSession('showBanner');
        vars.isToken = false;
        vars.isPermanentLoggedIn = false;
        vars.isTempLoggedIn = false;
        vars.userData$.next(undefined);
        vars.userData.set(undefined);
      }
      return throwError(() => error);
    })
  );
};
